import React from "react";

type LogoSize = "minimal" | "normal";

type LogoProps = {
  size?: LogoSize;
};

export const Logo = ({
  size = "normal",
  ...props
}: LogoProps & React.SVGProps<SVGSVGElement>) => {
  if (size == "minimal") {
    return (
      <svg
        width="24"
        height="26"
        viewBox="0 0 27 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="12" y="1" width="3" height="13" fill="currentColor" />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="10"
          height="10"
        >
          <rect width="10" height="10" fill="currentColor" />
        </mask>
        <g mask="url(#mask0)">
          <circle cx="13.5" cy="13.5" r="8.5" stroke="currentColor" strokeWidth="3" />
        </g>
        <mask
          id="mask1"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="17"
          y="2"
          width="10"
          height="10"
        >
          <rect x="17" y="2" width="10" height="10" fill="currentColor" />
        </mask>
        <g mask="url(#mask1)">
          <circle cx="13.5" cy="13.5" r="8.5" stroke="currentColor" strokeWidth="3" />
        </g>
        <mask
          id="mask2"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="2"
          y="8"
          width="25"
          height="21"
        >
          <rect x="2" y="8" width="25" height="21" fill="currentColor" />
        </mask>
        <g mask="url(#mask2)">
          <circle cx="13.5" cy="13.5" r="8.5" stroke="currentColor" strokeWidth="3" />
        </g>
      </svg>
    );
  }
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 188.4 25.2"
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill="currentColor"
        d="M28.4 13v10.7c0 .2-.1.5-.3.6-.2.2-.4.3-.6.3h-2.3c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6V4.1c0-.2.1-.4.4-.4.2 0 .4 0 .6.2L38 15.7c.2.2.3.2.5.2.1-.1.2-.2.2-.5V4.5c0-.2.1-.5.3-.6.2-.2.4-.3.6-.3h2.2c.2 0 .5.1.6.3.2.2.3.4.3.6v19.6c0 .2-.1.4-.4.4-.2 0-.5 0-.6-.2L29.1 12.7c-.2-.2-.3-.2-.5-.1-.1 0-.2.1-.2.4zm34-8.8c.9.4 1.7.9 2.3 1.6.3.3.6.7.9 1.1.3.4.5.8.7 1.3.4.8.6 1.8.6 2.8 0 1-.2 2-.5 2.9-.3.9-.8 1.6-1.5 2.3-.6.6-1.5 1.2-2.5 1.5-1 .4-2.2.6-3.5.6H55c-.2 0-.5.1-.6.3-.2.2-.3.4-.3.6v4.5c0 .2-.1.5-.2.6-.2.2-.4.3-.6.3H51c-.2 0-.5-.1-.6-.3-.2-.2-.3-.4-.3-.6V4.5c0-.2.1-.5.3-.6.2-.2.4-.3.6-.3h8.4c1.1 0 2.1.2 3 .6zM61 14.4c.4-.2.8-.5 1.1-.8.1-.2.3-.4.4-.6.1-.2.2-.4.2-.6.1-.4.2-.9.2-1.4 0-.5-.1-.9-.3-1.4-.2-.5-.4-.9-.7-1.2-.3-.4-.7-.7-1.2-.9-.5-.2-1-.3-1.7-.3h-4c-.2 0-.5.1-.6.3-.2.2-.3.4-.3.6v5.8c0 .2.1.5.3.6.2.2.4.3.6.3h4.4c.6-.1 1.2-.2 1.6-.4zm17.7 10.5c-1.5 0-2.9-.3-4.2-.9-1.3-.6-2.5-1.3-3.4-2.3-1-1-1.8-2.1-2.3-3.4-.6-1.3-.9-2.7-.9-4.2s.3-2.9.9-4.2c.4-1.4 1.2-2.5 2.2-3.5s2.1-1.8 3.4-2.3c1.3-.6 2.7-.9 4.2-.9s2.9.3 4.2.9c1.3.6 2.5 1.4 3.4 2.3 1 1 1.8 2.1 2.3 3.5.6 1.3.9 2.7.9 4.2s-.3 2.9-.9 4.2c-.6 1.3-1.4 2.5-2.3 3.4-1 1-2.1 1.8-3.4 2.3-1.2.7-2.6.9-4.1.9zm0-18c-1 0-1.8.2-2.7.6-.8.4-1.6.9-2.2 1.6-.6.6-1.1 1.4-1.5 2.3-.4.9-.5 1.8-.5 2.7 0 1 .2 1.9.5 2.7.4.9.9 1.6 1.5 2.3.6.7 1.3 1.2 2.2 1.6.8.4 1.7.6 2.7.6 1 0 1.8-.2 2.7-.6.8-.4 1.6-.9 2.2-1.6.6-.7 1.1-1.4 1.5-2.3.4-.9.5-1.8.5-2.7 0-.9-.2-1.8-.5-2.7-.4-.9-.9-1.6-1.5-2.3-.6-.6-1.3-1.2-2.2-1.6-.9-.4-1.8-.6-2.7-.6zm15.9 17.6h-2.3c-.2 0-.5-.1-.6-.3-.2-.2-.2-.4-.2-.6V4.5c0-.2.1-.5.2-.6.2-.2.4-.3.6-.3h2.3c.2 0 .5.1.6.3.2.2.3.4.3.6v19.1c0 .2-.1.5-.3.6-.1.3-.3.3-.6.3zm7.9-11.5v10.7c0 .2-.1.5-.3.6-.2.2-.4.3-.6.3h-2.3c-.2 0-.4-.1-.6-.3-.2-.2-.3-.4-.3-.6V4.1c0-.2.1-.4.4-.4.2 0 .4 0 .6.2L112 15.8c.2.2.3.2.5.2.1-.1.2-.2.2-.5v-11c0-.2.1-.5.3-.6.2-.2.4-.3.6-.3h2.2c.2 0 .5.1.6.3.2.2.3.4.3.6v19.6c0 .2-.1.4-.4.4-.2 0-.5 0-.6-.2l-12.5-11.7c-.2-.2-.3-.2-.5-.1-.1.1-.2.2-.2.5zm31.2-5.9h-4.2c-.2 0-.5.1-.6.3-.2.2-.3.4-.3.6v15.6c0 .2-.1.5-.3.6-.2.2-.4.3-.6.3h-2.2c-.2 0-.5-.1-.6-.3-.2-.2-.3-.4-.3-.6V8c0-.2-.1-.5-.3-.6-.2-.2-.4-.3-.6-.3h-4.2c-.2 0-.5-.1-.6-.3-.2-.2-.3-.4-.3-.6V4.5c0-.2.1-.5.3-.6.2-.2.4-.3.6-.3h14.2c.2 0 .5.1.6.3.2.2.3.4.3.6v1.8c0 .2-.1.5-.3.6-.2.2-.4.2-.6.2zm6.4 17.4h-2.3c-.2 0-.5-.1-.6-.3-.2-.2-.2-.4-.2-.6V4.5c0-.2.1-.5.2-.6.2-.2.4-.3.6-.3h2.3c.2 0 .5.1.6.3.2.2.3.4.3.6v19.1c0 .2-.1.5-.3.6-.2.3-.4.3-.6.3zM12.3 13.8H10c-.2 0-.5-.1-.6-.2-.2-.1-.2-.2-.2-.4V.9c0-.2.1-.3.2-.4.2-.2.4-.2.6-.2h2.3c.2 0 .5.1.6.2.2.1.3.2.3.4v12.3c0 .2-.1.3-.3.4-.2.1-.4.2-.6.2z"
      />
      <path
        fill="currentColor"
        d="M21.2 9.8c-.6-1.3-1.4-2.5-2.3-3.5-1-1-2.1-1.8-3.4-2.3-.1 0-.1 0-.2-.1v4.4c.3.2.5.4.8.7.6.6 1.1 1.4 1.5 2.3.4.9.5 1.8.5 2.7 0 1-.2 1.9-.5 2.7-.4.9-.9 1.6-1.5 2.3-.6.7-1.3 1.2-2.2 1.6-.8.4-1.7.6-2.7.6-1 0-1.8-.2-2.7-.6-.8-.4-1.6-.9-2.2-1.6-.6-.7-1.1-1.4-1.5-2.3-.4-.9-.5-1.8-.5-2.7 0-.9.2-1.8.5-2.7.4-.9.9-1.6 1.5-2.3.2-.2.5-.5.8-.7V4h-.2c-1.3.6-2.4 1.4-3.4 2.4S1.7 8.5 1.2 9.9c-.6 1.3-.9 2.7-.9 4.2s.3 2.9.9 4.2c.6 1.3 1.4 2.5 2.3 3.4 1 1 2.1 1.8 3.4 2.3 1.3.6 2.7.9 4.2.9s2.9-.3 4.2-.9c1.3-.6 2.5-1.3 3.4-2.3 1-1 1.8-2.1 2.3-3.4.6-1.3.9-2.7.9-4.2.1-1.5-.2-2.9-.7-4.3zM164.6 14v1.8c-.1 1.4-.5 2.6-1.1 3.7-.6 1.1-1.4 2.1-2.3 2.9-.9.8-2 1.5-3.3 1.9-1.2.5-2.5.7-3.9.7-1.5 0-2.9-.3-4.2-.9-1.3-.6-2.5-1.4-3.5-2.3-1-1-1.8-2.2-2.3-3.4-.6-1.3-.9-2.7-.9-4.2s.3-2.9.9-4.2c.3-.7.6-1.3 1-1.9.4-.6.8-1.1 1.3-1.6 1-1 2.2-1.7 3.5-2.3 1.3-.6 2.7-.9 4.2-.9 1.9 0 3.6.4 5.2 1.3 1.3.7 2.4 1.7 3.3 2.8.2.2.2.4.2.6 0 .2-.2.4-.4.5l-1.9 1.2c-.2.1-.4.2-.7.1l-.6-.3c-.3-.3-.5-.6-.8-.9-.3-.3-.6-.5-1-.7-1-.6-2.1-.9-3.2-.9-.9 0-1.8.2-2.7.6-.9.4-1.6.9-2.2 1.6-.6.6-1.1 1.4-1.5 2.3-.4.9-.5 1.8-.5 2.7 0 1 .2 1.9.5 2.7.4.9.9 1.6 1.5 2.3.6.6 1.3 1.2 2.2 1.5.8.4 1.7.6 2.7.6.7 0 1.4-.1 2.1-.3.7-.2 1.3-.5 1.8-.9s1-.9 1.5-1.4c.2-.3.4-.7.6-1 .1-.2.1-.4 0-.6-.1-.2-.3-.2-.6-.2h-6c-.2 0-.5-.1-.6-.3-.2-.2-.3-.4-.3-.6v-2c0-.2.1-.5.3-.6.2-.2.4-.3.6-.3h10.3c.2 0 .5.1.6.3.1.1.2.3.2.6zm12.6 10.9c-1.5 0-2.9-.3-4.2-.9-1.3-.6-2.5-1.3-3.4-2.3-1-1-1.8-2.1-2.3-3.4-.6-1.3-.9-2.7-.9-4.2s.3-2.9.9-4.2c.6-1.3 1.3-2.5 2.3-3.5s2.1-1.8 3.4-2.3c1.3-.6 2.7-.9 4.2-.9s2.9.3 4.2.9c1.3.6 2.5 1.4 3.4 2.3 1 1 1.8 2.1 2.3 3.5.6 1.3.9 2.7.9 4.2s-.3 2.9-.9 4.2c-.6 1.3-1.4 2.5-2.3 3.4-1 1-2.1 1.8-3.4 2.3-1.3.7-2.7.9-4.2.9zm0-18c-1 0-1.8.2-2.7.6-.8.4-1.6.9-2.2 1.6-.6.6-1.1 1.4-1.5 2.3-.4.9-.5 1.8-.5 2.7 0 1 .2 1.9.5 2.7.4.9.9 1.6 1.5 2.3.6.7 1.3 1.2 2.2 1.6.8.4 1.7.6 2.7.6 1 0 1.8-.2 2.7-.6.8-.4 1.6-.9 2.2-1.6.6-.7 1.1-1.4 1.5-2.3.4-.9.5-1.8.5-2.7 0-.9-.2-1.8-.5-2.7-.4-.9-.9-1.6-1.5-2.3-.6-.6-1.3-1.2-2.2-1.6-.9-.4-1.8-.6-2.7-.6z"
      />
    </svg>
  );
};
